import React, {useContext, useState} from "react";
import PrintingComponent from "../../components/printingComponent";
import MembershipReport from "./Report/MembershipReport";
import Select from "react-select";
import {MainContext} from "../../context/MainContext";
import {memberReport} from "./Presence/memberReport";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";

export default function AthetesReport({ athleteId }:any) {
    const { club} = useContext(MainContext)

    const [print, setPrint] = useState<any>({})
    const [status, setStatus] = useState<any>('')
    const [startDate, setStartDate] = useState<any>(dayjs().subtract(1, 'month').startOf('month'))
    const [endDate, setEndDate] = useState<any>(dayjs().subtract(1, 'month').endOf('month'))

    const childToParent = (childdata:any) => {
        setPrint({imprimir:false})
    }

    const buildFiltro = () => ({
        status,
        period: {
            startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : undefined,
            endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : undefined,
        },
    })

    // useEffect(() => {
        // setPageTitle("Relatório de Sócios")
    // }, [])

    return (
        <>
            <div>
                <div className="row g-3 mt-1">
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                        <div className="col-md-4">
                            <label className="form-label">Data inicial</label>
                            <DesktopDatePicker
                                className="form-control sadate"
                                value={startDate}
                                onChange={(evento) => setStartDate(evento)}
                                slotProps={{field: {clearable: true}}}
                            />
                        </div>

                        <div className="col-md-4">
                            <label className="form-label">Data final</label>
                            <DesktopDatePicker
                                className="form-control sadate"
                                value={endDate}
                                onChange={(evento) => setEndDate(evento)}
                                slotProps={{field: {clearable: true}}}
                            />
                        </div>
                    </LocalizationProvider>

                    <div className="col-md-4">
                        <label htmlFor="status" className="form-label">Status</label>
                        <Select
                            defaultValue={{label: 'Todos', value: ''}}
                            options={[{label: 'Todos', value: ''}, {label: 'Ativos', value: '1'}, {label: 'Inativos', value: '0'}]}
                            value={[{label: 'Todos', value: ''}, {label: 'Ativos', value: '1'}, {label: 'Inativos', value: '0'}
                            ].find(option => option.value == status)}
                            name='status'
                            id='status'
                            onChange={(data: any) => {
                                setStatus(data.value)
                            }}
                        />
                    </div>
                </div>

                <div className="mt-3">
                    <button type="button" className="btn btn-primary"
                            onClick={() => setPrint({imprimir: true})}>
                        <i className="bi bi-printer-fill"></i> Imprimir
                    </button>

                    <button className="btn btn-warning mx-2 " onClick={() => memberReport(buildFiltro(), club)}>
                        <i className="bi bi-filetype-xlsx"></i> Exportar planilha
                    </button>
                </div>
            </div>
            {print.imprimir &&
                <PrintingComponent componentToPrint={<MembershipReport filtro={buildFiltro()}/>}
                                   textButon={""} childToParent={childToParent}/>
            }
        </>
    )
}
